import React from 'react'
import { connect } from 'react-redux'
import { jt, t } from 'ttag'
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Link } from 'react-router-dom'

import major from '@h2/assets/svg/icons/major.svg'
import all from '@h2/assets/svg/icons/allOpportunities.svg'
import college from '@h2/assets/svg/icons/college.svg'
import education from '@h2/assets/svg/icons/education.svg'
import certification from '@h2/assets/svg/icons/certification.svg'
import like from '@h2/assets/svg/icons/thumbsUpActive.svg'
import likeInactive from '@h2/assets/svg/icons/thumbsUpInactive.svg'
import dislike from '@h2/assets/svg/icons/thumbsDownActive.svg'
import disllikeInactive from '@h2/assets/svg/icons/thumbsDownInactive.svg'

import { loadInstructionalProgram, rateMajor, selectLocalTab } from '../../actions/majors'
import { removeForComparison, selectForComparison } from '../../actions/occupationProfile'
import ComparisonFooter from '../../components/ComparisonFooter'
import { generateClassName } from '../../actions'
import { openSigninDialog } from '../../actions/signinOrRegisterDialog'
import LoadingIndicator from '../../components/LoadingIndicator'
import { toggleModal } from '../../actions/modals'
import PopupJournal from '../../components/journal/PopupJournal'
import Share from '../../components/social/Share'
import { useInitDispatch, useTitleChange } from '../../util/hooks'

const LocalOpportunitySection = ({
  profile,
  selectedLocalTab,
  onSelectLocalTab,
  localOpportunitiesLoading,
  match
}) => {
  const localOpps = profile.localOpportunities || []
  const generateList = () => {
    //Loading, return loading sequence
    if (localOpportunitiesLoading) {
      return (
        <div className="row" style={{ minHeight: '300px' }}>
          <LoadingIndicator
            unContained={true}
            small={true}
            newSiteLook={dynamicValues.newSiteLook}
          />
        </div>
      )
    }

    //No results
    if (localOpps.length === 0) {
      return (
        <div style={{ minHeight: '300px' }}>
          <div className="no-results alert alert-warning">{t`No opportunities found`}</div>
        </div>
      )
    }

    return localOpps.map((l, idx) => {
      return (
        <li
          key={l.id}
          className={`result-type-icon ${l.resultType} ${
            idx % 2 === 0 ? 'even' : 'odd'
          }`}>
          <Link to={l.url}>{l.title}</Link>
        </li>
      )
    })
  }

  return (
    <div className="section">
      <h3>
        <span>{t`Your Opportunities`}</span>
      </h3>
      <div className="localactions">
        <a
          className={`actionitem ${selectedLocalTab == 0 ? 'selected' : 'all'}`}
          style={{ width: '25%' }}
          href="javascript:void(0)"
          onClick={() => onSelectLocalTab(profile.cipCode, 0)}>
          <img src={all} />
          {t`All`}
        </a>
        <a
          className={`actionitem ${selectedLocalTab == 5 ? 'selected' : 'all'}`}
          style={{ width: '25%' }}
          href="javascript:void(0)"
          onClick={() => onSelectLocalTab(profile.cipCode, 5)}>
          <img src={college} />
          {t`Institutions`}
        </a>
        <a
          className={`actionitem ${selectedLocalTab == 1 ? 'selected' : 'all'}`}
          style={{ width: '25%' }}
          href="javascript:void(0)"
          onClick={() => onSelectLocalTab(profile.cipCode, 1)}>
          <img src={education} />
          {t`Education & Training`}
        </a>
        <a
          className={`actionitem ${selectedLocalTab == 2 ? 'selected' : 'all'}`}
          style={{ width: '25%' }}
          href="javascript:void(0)"
          onClick={() => onSelectLocalTab(profile.cipCode, 2)}>
          <img src={certification} />
          {t`Certifications`}
        </a>
      </div>
      <ul className="localopportunities">
        {generateList()}
        <div className="row">
          <div className="col-xs-12">
            <Link
              className="btn-h2more pull-right"
              style={{ fontSize: '1.2rem' }}
              to={profile.collegeSearchUrl}>
              {t`View All`}
            </Link>
          </div>
        </div>
      </ul>
    </div>
  )
}
const MajorProfile = ({
  selectedProfile,
  selectedLocalTab,
  profileCache,
  onRateMajor,
  localOpportunitiesLoading,
  selectedOccupations,
  modals,
  jobZoneValues,
  onToggleModal,
  onSelectLocalTab,
  onSelectOccupationForComparison,
  onRemoveOccupationForComparison,
  match
}) => {
  useTitleChange(null)
  useInitDispatch(loadInstructionalProgram(match?.params.majorId), [
    match?.params.majorId
  ])

  const profile = selectedProfile

  if (!profile) {
    return <LoadingIndicator newSiteLook={dynamicValues.newSiteLook} />
  }
  //console.log(profile, profileCache, selectedProfile)

  const aboutSection = () => {
    return (
      <div className="section" id="collegeinfo">
        <h3>
          <span>{t`About This Program`}</span>
        </h3>
        <p>{profile.description}</p>
        <p>
          <Link
            className="btn-h2more pull-right"
            style={{ fontSize: '1.2rem' }}
            to={profile.collegeSearchUrl}>
            {t`Find Colleges`}
          </Link>
        </p>
      </div>
    )
  }
  const relatedOccupations = () => {
    return (
      <div className="section" id="collegeinfo">
        <h3>
          <span>{t`Occupations That Employ this Program`}</span>
        </h3>
        <table className="table tbl">
          <thead>
            <tr>
              <th>
                <OverlayTrigger
                  trigger={['hover', 'focus', 'click']}
                  placement="top"
                  overlay={
                    <Tooltip placement="bottom">{t`Select up to four boxes below to see a side-by-side comparison of the items`}</Tooltip>
                  }>
                  <i
                    className="fal fa-eye"
                    aria-hidden="true"
                    title={t`Select up to four boxes below to see a side-by-side comparison of the items`}>
                  </i>
                </OverlayTrigger>
                <span className="sr-only">{t`Comparison`}</span>
              </th>
              <th>{t`Occupation`}</th>
              <th>{t`Job Zone`}</th>
            </tr>
          </thead>
          <tbody>
            {profile.occupations.map((m, i) => (
              <tr key={m.onetSoc} className={i % 2 == 0 ? 'even' : 'odd'}>
                <td>
                  <input
                    id={`check-${m.onetSoc}`}
                    type="checkbox"
                    {...(selectedOccupations.indexOf(m.onetSoc) >= 0
                      ? { checked: true }
                      : {})}
                    onChange={s => {
                      if (s.target.checked) {
                        s.target.checked = !!onSelectOccupationForComparison(m.onetSoc)
                      } else {
                        return onRemoveOccupationForComparison(m.onetSoc)
                      }
                    }}
                  />
                </td>
                <td>
                  <Link to={m.url}>{m.title}</Link>
                  {profile.occupationMeta.inBudget[m.onetSoc] && (
                    <OverlayTrigger
                      trigger={['hover', 'focus', 'click']}
                      placement="top"
                      overlay={
                        <Tooltip placement="bottom">{t`This occupation would satisfy the salary requirements from your budget.`}</Tooltip>
                      }>
                      <span
                        className="badge listing-badge budget defined"
                        title={t`This occupation would satisfy the salary requirements from your budget.`}>
                        <span>budget</span>
                      </span>
                    </OverlayTrigger>
                  )}
                  {(profile.occupationMeta.flags[m.onetSoc] || []).map(f => (
                    <OverlayTrigger
                      trigger={['hover', 'focus', 'click']}
                      placement="top"
                      overlay={<Tooltip placement="bottom">{f.description}</Tooltip>}>
                      <span
                        className={`badge listing-badge ${f.styleClass} defined`}
                        title={f.description}>
                        <span>{f.name}</span>
                      </span>
                    </OverlayTrigger>
                  ))}
                </td>
                <td>
                  <div>
                    {dynamicValues.newSiteLook ? (
                      <OverlayTrigger
                        trigger={['hover', 'focus', 'click']}
                        placement="right"
                        overlay={(
                          <Tooltip placement="bottom">
                            <div>
                              <b>{(jobZoneValues[m.jobZone] || {}).name}</b>
                              <br />
                              {(jobZoneValues[m.jobZone] || {}).description}
                            </div>
                          </Tooltip>
                        )}>
                        <div className="job-zone">{m.jobZone}</div>
                      </OverlayTrigger>
                    ) : (
                      <span className="fa-stack h2-table-stack">
                        <span className="h2-jobzone fa-stack-2x"></span>
                        <span className="fa-stack-1x h2-text-stack">{m.jobZone}</span>
                      </span>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }
  const similarMajorsSection = () => {
    return (
      <div className="section" id="collegeinfo">
        <h3>
          <span>{t`Similar Majors`}</span>
        </h3>
        <ul style={{ columnCount: '2' }}>
          {profile?.similarMajors
            ?.filter(m => m.cipCode != profile.cipCode)
            .map(m => (
              <li>
                <Link to={m.majorDetailUrl}>{m.name}</Link>
              </li>
            ))}
        </ul>
      </div>
    )
  }
  const youAndOcc = () => {
    const per = profile.personalization
    const rating =
      profile.personalization && profile.personalization.hasOwnProperty('rating')
        ? profile.personalization.rating
        : null
    const lastView = new Date(profile.personalization.lastView).toLocaleDateString()

    return (
      <div>
        <div className=" youandocc">
          <h3>{t`You and This Program`}</h3>
          <div className="row">
            <div className="useractions col-xs-6">
              <div className="itemrating">
                <a
                  href="javascript:void(0)"
                  onClick={() => onRateMajor(profile.cipCode, 5)}>
                  <img
                    src={rating && rating > 3 ? like : likeInactive}
                    alt={t`Thumbs Up for Like Occupation Link`}
                  />
                </a>
                <a
                  href="javascript:void(0)"
                  onClick={() => onRateMajor(profile.cipCode, 1)}>
                  <img
                    src={rating && rating < 3 ? dislike : disllikeInactive}
                    alt={t`Thumbs down for Dislike Occupation Link`}
                  />
                </a>
                Your Rating
              </div>
            </div>
            <div className="useractions col-xs-6"></div>
            <div className="col-xs-offset-6 col-xs-3 history-item">
              <div className={`personalize-history`}>
                <h4
                  className={
                    ((per && per.educationHistory) || []).length ? 'hasData' : ''
                  }>
                  {((per && per.educationHistory) || []).length || 0}
                </h4>
                <span>{t`Resumes`}</span>
                <button
                  onClick={() =>
                    (window.location = `/jobtools/resume/addeducation?type=major&cipCode=${profile.cipCode}`)}>
                  {t`Add`}
                </button>
              </div>
            </div>
            <div className="col-xs-3 history-item">
              <div className={`personalize-history`}>
                <h4 className={((per && per.journals) || []).length ? 'hasData' : ''}>
                  {((per && per.journals) || []).length || 0}
                </h4>
                <span>{t`Journals`}</span>
                <button onClick={() => onToggleModal('journal', true)}>{t`Add`}</button>
              </div>
            </div>
          </div>
          {profile.personalization.lastView && (
            <div className="lastView">{jt`You last viewed this on ${lastView}`}</div>
          )}
        </div>
      </div>
    )
  }
  const completionsInArea = profile.completionsInArea || {}
  const jobOpeningsInMajor = profile.jobOpeningsInMajor || {}

  return (
    <div id="profileinfocontainer">
      <div className="container">
        <div className="">
          <div className="headerBox row major">
            <div className="title-section col-sm-5">
              <h3>{profile.name}</h3>
              {profile.cluster && (
                <ul>
                  <li
                    className={`cluster-link cluster-${generateClassName(
                      profile.cluster.id
                    )}`}>
                    <Link to={profile.cluster.url}>
                      {t`A member of ${profile.cluster.name}`}
                    </Link>
                  </li>
                </ul>
              )}
            </div>
            <div className="lmi-callout col-sm-5">
              <div className="row">
                <div className="col-sm-6">
                  <h4>{t`Completions`}</h4>
                  <h5>
                    {completionsInArea.completionsTotal
                      ? completionsInArea.completionsTotal.toLocaleString()
                      : t`n/a`}
                  </h5>
                </div>
                <div className="col-sm-6">
                  <h4>{t`Institutions Offering`}</h4>
                  <h5>
                    {completionsInArea.institutionsOffering &&
                      completionsInArea.institutionsOffering.toLocaleString()}
                  </h5>
                </div>
                <div className="col-sm-6">
                  <h4>{t`Annual Job Openings`}</h4>
                  <h5>
                    {jobOpeningsInMajor.annualOpenings &&
                      jobOpeningsInMajor.annualOpenings.toLocaleString()}
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-sm-2 action-container">
              <a className="btn no-style media" href="javascript:void(0)" disabled={true}>
                <div
                  className="thumb"
                  style={{
                    backgroundImage: `url(${major})`
                  }}>
                </div>
              </a>
              <a
                className="btn share"
                href="javscript:void(0)"
                onClick={() => onToggleModal('share')}>
                <span className="sr-only">{t`Share`}</span>
              </a>
              <a className="btn print" href={profile.printUrl}>
                <span className="sr-only">{t`Print`}</span>
              </a>
              {/*<a className="btn" href="#"><i className="fal fa-flag"></i><span className="sr-only">Bookmark</span></a>*/}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-8">
            {aboutSection()}
            {similarMajorsSection()}
            {relatedOccupations()}
          </div>
          <div className="col-sm-4">
            {youAndOcc()}
            <LocalOpportunitySection
              profile={profile}
              selectedLocalTab={selectedLocalTab}
              onSelectLocalTab={onSelectLocalTab}
              localOpportunitiesLoading={localOpportunitiesLoading}
            />
          </div>
        </div>
      </div>
      <ComparisonFooter />
      <Modal
        bsSize="large"
        enforceFocus={false}
        show={modals && modals.selectedModal === 'journal'}
        onHide={() => onToggleModal(null)}>
        <Modal.Header closeButton>
          <h2>{t`Journal Entries`}</h2>
        </Modal.Header>
        <Modal.Body>
          {profile.personalization.journals && (
            <PopupJournal
              journals={profile.personalization.journals}
              objectType={profile.personalization.journalType}
              objectId={profile.cipCode}
              objectTitle={profile.name}
            />
          )}
        </Modal.Body>
      </Modal>
      <Modal
        bsSize="large"
        show={modals && modals.selectedModal === 'share'}
        onHide={() => onToggleModal(null)}>
        <Modal.Header closeButton>
          <h2>{t`Social`}</h2>
        </Modal.Header>
        <Modal.Body>{<Share />}</Modal.Body>
      </Modal>
    </div>
  )
}

export default connect(
  state => {
    return {
      ...state.college.majorProfile,
      modals: state.modals.major,
      jobZoneValues: state.jobZones.jobZoneValues,
      selectedOccupations: state.occupations.comparison.selectedOccupations
    }
  },
  dispatch => ({
    onRateMajor: (cipCode, rating) => {
      if (dynamicValues.userProfile) {
        dispatch(rateMajor(cipCode, rating))
      } else {
        dispatch(openSigninDialog('signIn'))
      }
    },
    onSelectLocalTab: (cipCode, t) => dispatch(selectLocalTab(cipCode, t)),
    onSelectOccupationForComparison: itm => {
      console.log(itm)
      dispatch(selectForComparison(itm))
    },
    onToggleModal: (modalName, requireLoggedIn) => {
      if (!!requireLoggedIn && !dynamicValues.userProfile) {
        dispatch(openSigninDialog('signIn'))
      } else {
        dispatch(toggleModal('major')(modalName))
      }
    },
    onRemoveOccupationForComparison: itm => dispatch(removeForComparison(itm))
  })
)(MajorProfile)
